import { IconButton, Tooltip } from "@mui/material";
import OpenInFullRoundedIcon from '@mui/icons-material/OpenInFullRounded';
import CloseFullscreenRoundedIcon from '@mui/icons-material/CloseFullscreenRounded';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { selectIsSidebarCollapsed, setIsSidebarCollapsed } from "@/features/layout/layoutSlice";
import useLayout from "@/features/layout/useLayout";

const CollapseBtn = () => {
  const isCollapsed = useSelector(selectIsSidebarCollapsed);
  const dispatch = useDispatch();
  const { isMobile } = useLayout();
  const { t } = useTranslation();
  
  if (isMobile) return null;
  return (
    <Tooltip 
      title={
        isCollapsed 
          ? t('sidebar_menu-size_title_shrink')
          : t('sidebar_menu-size_tooltip_expand')
        }
      placement="right"
    >
      <IconButton
        onClick={() => dispatch(setIsSidebarCollapsed(!isCollapsed))}
        size="small"
        // type="outlined"
        sx={{
          p: 1.5,
          m: 0.5,
          borderRadius: 2,
          marginRight: 'auto',
          transition: 'all 0.25s ease',
          '&:hover': { 
            bgcolor: 'action.hover', 
            transform: 'scale(1.05)' 
          }
        }}
      >
        {
          isCollapsed 
            ? <CloseFullscreenRoundedIcon fontSize="small"/> 
            : <OpenInFullRoundedIcon fontSize="small"/>
        }
      </IconButton>
    </Tooltip>
  )
}

export default CollapseBtn;